<script lang="ts" setup>
  import type { ContentCollectionItem } from '@nuxt/content'

  import type { Nullable } from '~/core/types'

  type Props = {
    content: Nullable<ContentCollectionItem>
  }
  const props = defineProps<Props>()
</script>

<template>
  <ContentRenderer
    v-if="props.content"
    class="c-markdown"
    :value="props.content"
  />
  <div v-else>
    Content not found
  </div>
</template>
<style>
.c-markdown {
  display: flex;
  width: 100%;
  max-width: 100rem;
  flex-direction: column;
  margin: 0 auto;
  color: var(--color-secondary);
  font-family: Open-Sans, sans-serif;
  font-size: 1em;
  font-weight: normal;

  h1,
  h2,
  h3,
  h5 {
    margin: 1em 0;
    white-space: normal;
  }

  h1 {
    font-size: 1.25em;
    font-weight: bold;
  }

  h2 {
    font-size: 1.125em;
    font-weight: bold;
  }

  h3 {
    font-size: 1em;
    font-weight: bold;
  }

  h5 {
    font-size: 0.875em;
    font-weight: bold;
    line-height: 1.125rem;
  }

  p {
    margin: 0.5em 0;
    font-size: 0.875em;
    line-height: 1.125rem;
  }

  a {
    color: var(--color-primary);
    text-decoration: underline;
  }

  em {
    font-style: italic;
  }

  strong {
    font-weight: bold;
  }

  code {
    padding: 0.125rem 0.25rem;
    border-radius: 4px;
    background-color: var(--color-secondary-light);
    font-family: SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace;
  }

  ul {
    margin-top: 1em;

    li {
      font-size: 0.875em;
      line-height: 1.5rem;

      &::before {
        content: " - ";
      }
    }
  }

  table {
    display: block;
    width: 100%;
    margin: 1em 0;
    overflow-x: auto;
    border-collapse: collapse;
    font-size: 0.875em;
    line-height: 1.125rem;

    th,
    td {
      padding: 0.5em 0.75em;
      border: 1px solid var(--color-secondary-light);
      text-align: left;
      vertical-align: top;
    }

    th {
      background-color: var(--color-secondary-light);
      font-weight: bold;
    }

    tr:nth-child(even) td {
      background-color: color-mix(in srgb, var(--color-secondary-light) 30%, white);
    }
  }

}

</style>
